import { IDeleteObraServicosControladosUseCase } from "../../../presentation/useCases/delete/delete_obra_servicos_controlados_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraServicosControladosUseCase
 */
export class DeleteObraServicosControladosUseCase implements IDeleteObraServicosControladosUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async deleteObraServicosControlados(id?: number): Promise<void> {
    await this.repository.deleteObraServicosControlados({ id });
  }
}
